import { render } from "./MovementManager.vue?vue&type=template&id=2c81c662&scoped=true"
import script from "./MovementManager.vue?vue&type=script&lang=js"
export * from "./MovementManager.vue?vue&type=script&lang=js"

import "./MovementManager.vue?vue&type=style&index=0&id=2c81c662&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2c81c662"]])

export default __exports__